import { render, staticRenderFns } from "./RegimenVideoEdit.vue?vue&type=template&id=f73de5d0"
import script from "./RegimenVideoEdit.vue?vue&type=script&lang=js"
export * from "./RegimenVideoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports